/* eslint-disable no-unused-vars */
import { Box, Group, Paper, Skeleton, Stack, Text } from '@mantine/core';
import Badge from 'components/Badge';
import Card from 'components/Card';
import { labelMapping } from 'constant/course';
import React from 'react';
import { HiOutlineBookmark } from 'react-icons/hi';
import { BasicInformation as BasicInformationData } from 'types/lcms/courses';
import LoadingText from './LoadingText';
import MaterialLink from '../courses/MaterialLink';

interface BasicInformationProps {
  beelajarID?: string;
  basicInformation?: BasicInformationData;
  loading?: boolean;
}

const BasicInformation: React.FC<BasicInformationProps> = ({
  beelajarID,
  basicInformation,
  loading = false
}) => {
  const { tags, startDateTime, endDateTime, ...others } = basicInformation || {};
  const tagList = tags && tags?.length > 0 ? tags[0].split(',') : [];
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineBookmark />
          <Text c={'dark'} fw={700}>
            Basic Information
          </Text>
        </Group>
        {loading && <LoadingText />}
        {!loading && (
          <>
            <Stack gap={0}>
              <Text c={'dark'} fw={600} fz={14}>
                Beelajar ID
              </Text>
              <Box>
                <MaterialLink
                  title={beelajarID}
                  linkMaterial={
                    beelajarID
                      ? `${process.env.REACT_APP_BEELAJAR_URL}/course/view.php?id=${beelajarID}`
                      : ''
                  }
                />
              </Box>
            </Stack>
            {Object.keys(others).map((key, i) => {
              if (key === 'learningContent') {
                return (
                  <Stack key={i} gap={0}>
                    <Text c={'dark'} fw={600} fz={14}>
                      {labelMapping[key] || key}
                    </Text>
                    <Paper withBorder p={24} style={{ overflow: 'auto' }}>
                      <div
                        dangerouslySetInnerHTML={{ __html: others[key as keyof typeof others] }}
                      />
                    </Paper>
                  </Stack>
                );
              }
              if (key === 'description') {
                return (
                  <Stack key={i} gap={0}>
                    <Text c={'dark'} fw={600} fz={14}>
                      {labelMapping[key] || key}
                    </Text>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: others[key as keyof typeof others]
                      }}
                      style={{ whiteSpace: 'pre-wrap' }}
                    />
                  </Stack>
                );
              }
              if (key === 'courseType' || key === 'jenisTraining') {
                return null;
              }
              return (
                <Stack gap={4} key={i}>
                  <Text c={'dark'} fw={600} fz={14}>
                    {labelMapping[key] || key}
                  </Text>

                  <Text fz={14} c={'secondary'}>
                    {others[key as keyof typeof others] || '-'}
                  </Text>
                </Stack>
              );
            })}
          </>
        )}
        <Stack gap={0}>
          <Text c={'dark'} fw={600} fz={14}>
            Tags
          </Text>
          <Group gap={4}>
            {tagList.map((tag, index) => (
              <Badge key={index} styleVariant='default'>
                {tag}
              </Badge>
            ))}

            {tagList?.length === 0 && '-'}
          </Group>
        </Stack>
      </Stack>
    </Card>
  );
};

export default BasicInformation;
